import React from 'react';
import { BookOpenIcon, UtensilsIcon, MapIcon, CoffeeIcon, AppleIcon } from 'lucide-react';
export function WhatYouGetSection() {
  const deliverables = [{
    icon: <BookOpenIcon className="w-8 h-8 text-[#F5C518]" data-id="element-155" />,
    title: 'La Guía Maestra de la Despensa Local',
    desc: 'Qué comprar (y qué evitar) en el D1, Ara y Éxito para ahorrar dinero.'
  }, {
    icon: <UtensilsIcon className="w-8 h-8 text-[#F5C518]" data-id="element-156" />,
    title: 'El Menú "7 Días de Fuego"',
    desc: 'Desayunos, almuerzos y cenas 100% Keto con ingredientes colombianos.'
  }, {
    icon: <MapIcon className="w-8 h-8 text-[#F5C518]" data-id="element-157" />,
    title: 'Manual de Supervivencia en la Calle',
    desc: 'Qué pedir en restaurantes y puestos de comida para no dañar la dieta.'
  }, {
    icon: <CoffeeIcon className="w-8 h-8 text-[#F5C518]" data-id="element-158" />,
    title: 'Lista de Snacks de Emergencia',
    desc: 'Opciones rápidas para calmar el "algo" sin morder un pan.'
  }, {
    icon: <AppleIcon className="w-8 h-8 text-[#F5C518]" data-id="element-159" />,
    title: 'El Semáforo de la Plaza',
    desc: 'Guía visual de frutas y verduras locales permitidas.'
  }];
  return <section className="bg-[#FAFAF5] text-[#1A1A1A] py-16 md:py-24 px-4" data-id="element-160">
      <div className="max-w-4xl mx-auto" data-id="element-161">
        <div className="text-center mb-16" data-id="element-162">
          <h2 className="font-montserrat font-black text-4xl md:text-5xl mb-4 uppercase" data-id="element-163">
            Lo que te llevas{' '}
            <span className="text-[#F5C518] drop-shadow-sm" data-id="element-164">HOY</span>
          </h2>
          <div className="w-24 h-1 bg-[#F5C518] mx-auto rounded-full" data-id="element-165"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-166">
          {deliverables.map((item, index) => <div key={index} className={`bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300 ${index === deliverables.length - 1 ? 'md:col-span-2 md:max-w-xl md:mx-auto w-full' : ''}`} data-id="element-167">
              <div className="bg-[#FAFAF5] w-16 h-16 rounded-xl flex items-center justify-center mb-6 border border-gray-100" data-id="element-168">
                {item.icon}
              </div>
              <h3 className="font-montserrat font-bold text-xl mb-3 text-[#1A1A1A]" data-id="element-169">
                {item.title}
              </h3>
              <p className="font-inter text-gray-600 leading-relaxed" data-id="element-170">
                {item.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}